/*
 * Thumbnail slider that scrolls on the vertical axis.
 *
 * Dawn's SliderComponent is horizontal-only: it measures with offsetLeft /
 * clientWidth and scrolls with scrollLeft. In a vertical column every item
 * reports offsetLeft 0, so sliderItemOffset collapses to 0 and update()
 * disables both arrows — which also stops them emitting click events.
 *
 * This subclass swaps the axis, but only above the desktop breakpoint where
 * the column layout applies. Below it, every method defers to the parent so
 * the mobile horizontal slider keeps Dawn's behaviour untouched.
 */
if (typeof SliderComponent !== 'undefined' && !customElements.get('vertical-thumbnail-slider')) {
  class VerticalThumbnailSlider extends SliderComponent {
    // Must match the breakpoint the column layout starts at in
    // section-main-product.css.
    get isVertical() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    initPages() {
      if (!this.isVertical) return super.initPages();

      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      if (!this.sliderItemOffset) return;

      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }

    update() {
      if (!this.isVertical) return super.update();
      if (!this.slider || !this.nextButton || !this.sliderItemsToShow) return;

      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset = 0) {
      if (!this.isVertical) return super.isSlideVisible(element, offset);

      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    }

    onButtonClick(event) {
      if (!this.isVertical) return super.onButtonClick(event);

      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
      if (!this.isVertical) return super.setSlidePosition(position);
      this.slider.scrollTo({ top: position, behavior: 'smooth' });
    }

    // media-gallery.js calls this to bring the active thumbnail into view.
    scrollToSlide(element) {
      if (!this.isVertical) {
        this.slider.scrollTo({ left: element.offsetLeft });
        return;
      }
      this.slider.scrollTo({ top: element.offsetTop, behavior: 'smooth' });
    }
  }

  customElements.define('vertical-thumbnail-slider', VerticalThumbnailSlider);
}
